import { render, staticRenderFns } from "./UpdateOptionProduct.vue?vue&type=template&id=06800497&scoped=true"
import script from "./UpdateOptionProduct.vue?vue&type=script&lang=js"
export * from "./UpdateOptionProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06800497",
  null
  
)

export default component.exports